// =====================================
//  重新上傳稿件 modal
//
//  @author: Gray
//  @time 2016 / 09 / 12
// =====================================

window.InifECMobileApp.directive('reuploadOrderitemFile', ['$rootScope', '$ngModal', '$timeout', '$q', 'OrderService',
    function ($rootScope, $ngModal, $timeout, $q, OrderService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var submit = function() {

                if($scope.isLoading) {
                    return;
                }

                var promise = [];
                var isError = false;

                for(var i = 0; i < $scope.orderitems.length; i++) {
                    var orderitem = $scope.orderitems[i];

                    if(orderitem.collationstatus != 303) {
                        continue;
                    }

                    if(!orderitem.newUserfileurl) {
                        isError = true;
                        continue;
                    }

                    promise.push(OrderService.uplaodOrderFileByUrl($scope.orderid, orderitem.orderitemid, orderitem.newUserfileurl));
                }

                if(isError) {

                    $rootScope.$broadcast("OPEN_SIMPLE_MESSAGE_MODAL", {
                        title: '部分商品尚未更新稿件',
                        desc: '請檢查是否所有的商品稿件都重新上傳了'
                    });

                    return;
                }

                $scope.isLoading = true;
                $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                    title: '正在更新稿件',
                });

                $q.all(promise).then(function(result) {
                    $scope.isLoading = false;
                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功更新稿件',
                    });

                    ($scope.callback) && $scope.callback();
                    closeModal();
                }, function(error) {
                    $scope.isLoading = false;
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                })
            }

            // -------------------------------
            // 上傳稿件
            // -------------------------------
            var uploadOrderitemFile = function(orderitem) {

                orderitem.userfileurl = orderitem.newUserfileurl;

                $rootScope.$broadcast('OPEN_UPLOAD_ORDERITEM_FILE_MODAL', {
                    orderitem: orderitem,
                    callback: function(userfileurl) {
                        orderitem.newUserfileurl = userfileurl;
                    }
                });
            }

            // -------------------------------
            // 取得商品圖片
            // -------------------------------
            var getOrderItemCoverImage = function(orderitem) {

                if(!orderitem || !orderitem.coverurl){
                    return "about:blank";
                }

                return orderitem.coverurl.replace("medium", "small");
            }

            // -------------------------------
            // 離開重新上傳稿件
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('reupload-orderitem-file-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('reupload-orderitem-file-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_REUPLOAD_ORDERITEM_FILE_MODAL', function(event, data) {
                
                if(data) {
                    $scope.callback = data.callback;
                    $scope.orderid = data.orderid;
                    $scope.orderitems = shallowCopy(data.orderitems);

                    for(var i = 0; i < $scope.orderitems.length; i++) {
                        var orderitem = $scope.orderitems[i];
                        orderitem.newUserfileurl = '';
                        orderitem.userfileurl = '';
                    }

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.isLoading = false;
            $scope.isError = false;

            $scope.orderitems = [];

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.uploadOrderitemFile = uploadOrderitemFile;
            $scope.getOrderItemCoverImage = getOrderItemCoverImage;
            $scope.submit = submit;
            $scope.cancel = cancel; // 離開重新上傳稿件

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/reupload_orderitem_file.html";
        _dir.controller = controller;

        return _dir;
    }]
);